import { NgModule } from '@angular/core';
import { FileUploadComponent } from './file-upload.component';
import { DotBounceLoadingEffectComponent } from '../dot-bounce-loading-effect/dot-bounce-loading-effect.component';
import { DotBounceLoadingEffectModule } from '../dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [FileUploadComponent],
	imports: [DotBounceLoadingEffectModule, FontAwesomeModule, CommonModule],
	exports: [FileUploadComponent],
})
export class FileUploadModule {}
